import React from "react";
import { Link } from "react-router-dom";

function Terms_conditions_header(){

    return(
        <div className="terms-conditions-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>قوانین و مقررات</h1>
                        <div className="breadcrumbs">
                            <Link to="/">صفحه اصلی</Link>
                            <i className="fas fa-angle-left"></i>
                            <span className="current-page">قوانین و مقررات</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Terms_conditions_header;